import { render, staticRenderFns } from "./OrderMgmt.vue?vue&type=template&id=301a410d"
import script from "./OrderMgmt.vue?vue&type=script&lang=js"
export * from "./OrderMgmt.vue?vue&type=script&lang=js"
import style0 from "./OrderMgmt.vue?vue&type=style&index=0&id=301a410d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports